﻿export function replaceByIndex(source: string, replaceWith: string, index: number): string {
    return source.substring(0, index) + replaceWith + source.substring(index + 1);
}

export function isEmptyOrWhiteSpace(str: string | null | undefined): boolean {
    if (str == null || str === undefined || str.length === 0) {
        return true;
    }

    if (str.replace(/\s/g, '').length === 0) {
        return true;
    }

    return false;
}